import React, {  useState } from "react";
import { Cron } from 'react-js-cron'
import 'react-js-cron/dist/styles.css'

function CronComponent({ value, handle }) {
  const [error, onError] = useState()

  return (
    <div>
      <label htmlFor="factoryCode" className="form-label">
        Cron Expression
      </label>
      <input
        className={`mt-2  w-100 h-100 py-1 px-2  `}
        value={value}
        onChange={(event) => {
          console.log(event.target.value)
          // handle('expression',event.target.value)
        }}
        disabled
      />
      <hr class="hr" />
      <Cron
        value={value}
        setValue={(newValue) => {
          console.log('297', newValue)
          handle('expression', newValue)
        }}

        onError={onError}
      />
      {error && <p style={{ marginTop: 20 }}>
        Error: {error ? error.description : 'undefined'}
      </p>}
    </div>
  )
}
export default CronComponent;